import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { SidePanelLayer } from "@nova/constants"
import { useAppSelector } from "integrations/redux/hooks"
import { selectUserLocationShareById } from "features/entity-caching/flights/selectors"
import { useUserLocationShareDownloadButtonData } from "plugins/UserLocationShare/useUserLocationShareDownloadButtonData"

export const InspectorPanelUserLocationShareData = ({ id }: { id: string }) => {
    const share = useAppSelector(selectUserLocationShareById(id))
    const downloadOptions = useUserLocationShareDownloadButtonData(id)
    if (!share) return null

    return (
        <div className="mb-2 flex flex-col gap-2 shrink min-h-0">
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />
            <InspectorPanelMetadata
                entity={share as SidePanelLayer}
                completedUploadCount={0}
                hideFileCount
            />
        </div>
    )
}
